import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/moneyout-general-types/moneyout/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
